import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import classNames from 'classnames';
import {
  disabledText,
  grey700, secondary300,
} from 'themes/colors';

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    width: 'fit-content',
    height: '1.5rem',
    borderRadius: '3.438rem',
    border: `1px solid ${disabledText}`,
    fontSize: '0.75rem',
    fontWeight: 600,
    '& > div': {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 0.5rem',
      '&:first-child': {
        backgroundColor: secondary300,
        borderRadius: '3.438rem 0 0 3.438rem',
      },
    },
    '&.inactive': {
      opacity: 0.5,
      '& > div': {
        color: grey700,
      },
    },
  },
}));

// disable eslint
/* eslint-disable */

const Counter = ({ value = 0, max = 0 }) => {
  const classes = useStyles();
  const isInactive = value >= max;
  return (
    <div className={classNames(classes.wrapper, { inactive: isInactive })}>
      <div>{value}</div>
      <div>{max}</div>
    </div>
  );
};

Counter.propTypes = {
  value: PropTypes.number,
  max: PropTypes.number,
};

export default Counter;
